<div class="cx-item-list-row" *ngFor="let item of items; let i = index">
  <div class="cx-item-list-items">
    <sd-order-item [item]="item" [promotionLocation]="promotionLocation"></sd-order-item>
  </div>
</div>
